import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../SearchWidget.module.scss';

const Errors = ({show, children}) => {

    if (!show) {
        return null;
    }

    return (
        <div className={styles.errorsContainer}>
             <span>
                 {children}
             </span>
        </div>
    );
};

Errors.propTypes = {
    show: PropTypes.bool,
    children: PropTypes.any,
};

Errors.defaultProps = {
    show: true,
    children: null
};

export default Errors;
